import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config/baseUrl";
import Loading from "./Loading";

const PartnershipModal = ({
  isOpen,
  onClose,
  userId,       // display id (e.g. A20005) — shown in the title
  userMongoId,  // mongo _id — used for the API call
}) => {
  const [parentShare, setParentShare] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !userMongoId) return;
    let cancelled = false;
    const fetchInfo = async () => {
      setLoading(true);
      setParentShare(null);
      try {
        const token = localStorage.getItem("token");
        const baseUrl = localStorage.getItem("custom_base_url") || API_BASE_URL;
        const res = await axios.get(`${baseUrl}/api/partnership-info`, {
          params: { userId: userMongoId },
          headers: { Authorization: "Bearer " + token },
        });
        if (cancelled) return;
        const d = res.data;
        setParentShare(d?.success === false ? null : d?.partnership ?? null);
      } catch {
        if (!cancelled) setParentShare(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchInfo();
    return () => {
      cancelled = true;
    };
  }, [isOpen, userMongoId]);

  if (!isOpen) return null;

  const renderTable = function (title, headers, data) {
    return (
      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-base">{title}</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead>
              <tr className="bg-[#2c3e50] text-white">
                {headers.map((header, index) => (
                  <th key={index} className="border border-gray-400 p-2 text-left">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white">
                {data.map((value, index) => (
                  <td key={index} className="border border-gray-300 p-2">
                    {value}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // API shape: partnership.<section>.{admin,superAdmin,miniAdmin,master,super,agent,client}
  // Columns shown: S.Ad(superAdmin), Mini(miniAdmin), Master, Super, Agent [, Client]
  const shareRow = (section) => {
    const s = parentShare?.[section] || {};
    return [s.superAdmin ?? 0, s.miniAdmin ?? 0, s.master ?? 0, s.super ?? 0, s.agent ?? 0];
  };
  const commRow = (section) => {
    const s = parentShare?.[section] || {};
    return [s.superAdmin ?? 0, s.miniAdmin ?? 0, s.master ?? 0, s.super ?? 0, s.agent ?? 0, s.client ?? 0];
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto mx-4">
        <div className="flex items-center justify-between p-4 bg-[#2c3e50] text-white rounded-t-lg">
          <h3 className="text-lg font-normal">
            Partnership Info - {userId}
          </h3>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300 text-2xl leading-none"
          >
            ×
          </button>
        </div>
        <div className="p-6">
          {loading ? (
            <div className="flex justify-center py-8">
              <Loading />
            </div>
          ) : parentShare ? (
            <>
              {renderTable("Match Share", ["S.Ad", "Mini", "Master", "Super", "Agent"], shareRow("matchShare"))}
              {renderTable("Match Commission", ["S.Ad", "Mini", "Master", "Super", "Agent", "Client"], commRow("matchCommission"))}
              {renderTable("Session Commission", ["S.Ad", "Mini", "Master", "Super", "Agent", "Client"], commRow("sessionCommission"))}
              {renderTable("Casino Share", ["S.Ad", "Mini", "Master", "Super", "Agent"], shareRow("casinoShare"))}
              {renderTable("Casino Commission", ["S.Ad", "Mini", "Master", "Super", "Agent", "Client"], commRow("casinoCommission"))}
              {renderTable("Matka Share", ["S.Ad", "Mini", "Master", "Super", "Agent"], shareRow("matkaShare"))}
              {renderTable("Matka Commission", ["S.Ad", "Mini", "Master", "Super", "Agent", "Client"], commRow("matkaCommission"))}
              
              <div className="flex justify-end mt-6">
                <button
                  onClick={onClose}
                  className="bg-[#2c3e50] text-white px-8 py-2 rounded hover:bg-[#34495e]"
                >
                  Close
                </button>
              </div>
            </>
          ) : (
            <p className="text-center text-gray-500 py-8">
              No partnership data found
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PartnershipModal;
